import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLockOpenFill = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M18 1.5C20.9 1.5 23.25 3.85 23.25 6.75V10.5C23.25 10.6989 23.171 10.8897 23.0303 11.0303C22.8897 11.171 22.6989 11.25 22.5 11.25C22.3011 11.25 22.1103 11.171 21.9697 11.0303C21.829 10.8897 21.75 10.6989 21.75 10.5V6.75C21.75 5.75544 21.3549 4.80161 20.6517 4.09835C19.9484 3.39509 18.9946 3 18 3C17.0054 3 16.0516 3.39509 15.3483 4.09835C14.6451 4.80161 14.25 5.75544 14.25 6.75V9.75C15.0456 9.75 15.8087 10.0661 16.3713 10.6287C16.9339 11.1913 17.25 11.9544 17.25 12.75V19.5C17.25 20.2956 16.9339 21.0587 16.3713 21.6213C15.8087 22.1839 15.0456 22.5 14.25 22.5H3.75C2.95435 22.5 2.19129 22.1839 1.62868 21.6213C1.06607 21.0587 0.75 20.2956 0.75 19.5V12.75C0.75 11.9544 1.06607 11.1913 1.62868 10.6287C2.19129 10.0661 2.95435 9.75 3.75 9.75H12.75V6.75C12.75 3.85 15.1 1.5 18 1.5Z",
		fill: "currentcolor"
	})]
});
export default SvgLockOpenFill;
